<template>
  <div
    class="change-value"
    :class="{'editor-box': data[historyType + 'fieldtype'] === 'editor'}"
  >
    <span
      v-if="data.fieldauth === 1"
      class="fs-warning sensitive"
    >{{ $t('message["345"]') }}</span>
    <span
      v-else-if="data.isdeletefield"
      class="value fs-warning"
    >{{ $t('message["332"]') }}</span>
    <div
      v-else-if="data[historyType + 'fieldtype'] === 'tag' && data.fieldvalue && $toType(data.fieldvalue) === 'string'"
      class="tags"
    >
      <span
        v-for="(item, i) in data.fieldvalue.split(',')"
        :key="i"
        class="tag"
      >{{ item }}</span>
    </div>
    <div
      v-else-if="data[historyType + 'fieldtype'] === 'file' && data.fieldvalue.length"
      class="file-list"
    >
      <a
        v-for="(file, i) in data.fieldvalue"
        :key="i"
        class="file textOverflow"
        @click="handleclickGallery(data.fieldvalue, i)"
      >{{ file.file_name }}</a>
    </div>
    <div
      v-else-if="data[historyType + 'fieldtype'] === 'editor'"
      class="editor quill-editor"
    >
      <div
        class="html ql-editor"
        v-html="$xss(data.fieldvalue, $xssOptions)"
      />
    </div>
    <!-- 来源编辑-开发人员变更记录 -->
    <div
      v-else-if="valueKey === 'dev_userid'"
      class="dev_userid"
    >
      <span v-if="!data.fieldvalue || !data.fieldvalue.length || data.fieldvalue === '[]'">- -</span>
      <span v-else>{{ data.fieldvalueData.dev_truename }}<i class="fs-gray"> [{{ data.fieldvalueData.dev_rolename }}<em v-if="data.fieldvalueData.dev_groupname">/ {{ data.fieldvalueData.dev_groupname }}</em>]</i></span>
    </div>
    <span
      v-else
      class="value"
    >{{ data.isdelete ? '' : ((!data.fieldvalue || !data.fieldvalue.length)) ? '- -' : data.fieldvalue }}</span>
  </div>
</template>

<script>

export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    historyType: {
      type: String,
      default: ''
    },
    valueKey: {
      type: String,
      default: ''
    }
  },

  methods: {
    handleclickGallery (fileList, i) {
      let item = fileList[i]
      if (item.file_type.indexOf('image') === -1) {
        this.$confirm({
          title: '是否下载？',
          okText: '确定',
          cancelText: '取消',
          centered: true,
          onOk: () => {
            this.$downloadFile(item.url || item.file_url)
          }
        })
      } else {
        this.$bus.$emit('getFileGallery', fileList, i)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
i, em {
  font-style: normal;
}
.change-value {
  flex: 1;
  padding: 0 12px;
  &.editor-box {
    width: 350px;
    padding: 0;
    margin: 0 12px;
    word-break: break-all;
  }
  .value {
    word-break: break-all;
    line-height: 1.2;
  }
}
.sensitive {
  font-size: 12px;
  line-height: 24px;
}
.editor {
  display: block;
  height: 160px;
  border: solid 1px $gray4;
  border-radius: 4px;
  .ql-editor ::v-deep {
    img {
      max-width: 100%;
    }
  }
}
.tags {
  .tag {
    display: inline-block;
    margin-right: 16px;
    margin-bottom: 12px;
    padding: 2px 4px;
    line-height: 1.2;
    font-size: 12px;
    color: $gray2;
    border: solid 1px $gray4;
    border-radius: 4px;
  }
}

.file-list {
  .file {
    display: block;
    width: 100%;
    margin: 5px 0;
  }
}
</style>
